import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * usePublicDrivers — fetches /api/drivers/public once per page-load and caches
 * the result module-side. All ProductCard instances share the same promise so
 * we never refetch.
 *
 * The response is strictly the public, whitelisted shape — no admin fields,
 * no tokens. See /api/drivers/public in components_drivers.py.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;

export function _resetPublicDriversCache() {
  _cache = null;
  _inflight = null;
}

export default function usePublicDrivers() {
  const [drivers, setDrivers] = useState(_cache || []);
  const [loading, setLoading] = useState(_cache === null);

  useEffect(() => {
    if (_cache !== null) {
      setDrivers(_cache);
      setLoading(false);
      return;
    }
    if (!_inflight) {
      _inflight = axios.get(`${API}/drivers/public`)
        .then(r => {
          _cache = r.data?.drivers || [];
          return _cache;
        })
        .catch(() => {
          _cache = [];
          return _cache;
        });
    }
    _inflight.then(list => {
      setDrivers(list);
      setLoading(false);
    });
  }, []);

  return { drivers, loading };
}
